import { render } from "./FormIndex.vue?vue&type=template&id=0d3497c6&scoped=true&ts=true"
import script from "./FormIndex.vue?vue&type=script&lang=ts"
export * from "./FormIndex.vue?vue&type=script&lang=ts"

import "./FormIndex.vue?vue&type=style&index=0&id=0d3497c6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3497c6"]])

export default __exports__